export default __webpack_public_path__ + "static/media/column_dots.4bd84cfb.svg";